import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassPointer: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="compass-pointer, arrow, route"><path d="M12.0006 1.93555C12.3097 1.93569 12.5916 2.11481 12.7233 2.39453L20.9733 19.9268C21.112 20.2219 21.0568 20.5719 20.8346 20.8105C20.6122 21.0492 20.2668 21.1284 19.9625 21.0107L12.0006 17.9287L4.03869 21.0107C3.7344 21.1285 3.38913 21.0492 3.16662 20.8105C2.94427 20.5718 2.8891 20.222 3.02795 19.9268L11.2779 2.39453C11.4097 2.11478 11.6914 1.93555 12.0006 1.93555Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCompassPointer;
